import { LocationQuery } from 'vue-router';

import { type Dictionary } from '@/types';

import { LayoutSolutionRequest } from '@/types';

export const isLayoutSolutionActive = (query: LocationQuery): boolean =>
  !!query && ['l', 'a', 'incsubs'].some((param) => Object.hasOwnProperty.call(query, param));

export const HOMEGATE_AGENCY = 'default';

export const getLayoutSolutionRequest = (
  query: LocationQuery,
): LayoutSolutionRequest | undefined => {
  if (isLayoutSolutionActive(query)) {
    const showSearchBarFromQuery = query.sb === '1';

    return {
      agency: (query.a || HOMEGATE_AGENCY) as string,
      layout: (query.layout || 'neutral') as string,
      includeSubAgencies: query.incsubs === '1',
      withSearchbar: !['0', '1'].includes(query.sb as string) ? undefined : showSearchBarFromQuery,
      primaryColor: (query.pc || '') as string,
      primaryTextColor: (query.ptc || '') as string,
      hideLayoutElements: query.hle === '1',
    };
  }
};

export function getLayoutSolutionRequestQueryParameters(
  query: Dictionary<string | (string | null)[]>,
): Record<string, string> {
  const request = getLayoutSolutionRequest(query);

  if (!request) {
    return {};
  }

  return {
    l: request.layout,
    ...(request.agency !== HOMEGATE_AGENCY && { a: request.agency }),
    ...(request.includeSubAgencies !== undefined && {
      incsubs: request.includeSubAgencies ? '1' : '0',
    }),
    ...(request.withSearchbar !== undefined && { sb: request.withSearchbar ? '1' : '0' }),
    ...(request.primaryColor && { pc: request.primaryColor }),
    ...(request.primaryTextColor && { ptc: request.primaryTextColor }),
    ...(request.hideLayoutElements && { hle: '1' }),
  };
}

export function isValidCssHexColor(color: string | undefined): boolean {
  if (!color) {
    return false;
  }

  return (color.length === 6 || color.length === 3) && color.match(/^[0-9A-Fa-f]+$/) !== null;
}
